import jsPDF from 'jspdf';
import { gujaratiFontBase64 } from '../assets/fonts/GujaratiFont';
import { BasicDetailsModel } from '../models/BasicDetails';
import { NomineeDetailsModel } from '../models/NomineeDetails';
import { HealthDeclarationModel } from '../models/HealthDeclaration';

export const generateRegistrationPDF = (
  basicDetails: BasicDetailsModel,
  nomineeDetails: NomineeDetailsModel,
  healthDeclaration: HealthDeclarationModel
) => {
  const doc = new jsPDF();

  // Add and set Gujarati font
  if (gujaratiFontBase64) {
    doc.addFileToVFS('NotoSansGujarati.ttf', gujaratiFontBase64);
    doc.addFont('NotoSansGujarati.ttf', 'NotoSansGujarati', 'normal');
    doc.addFont('NotoSansGujarati.ttf', 'NotoSansGujarati', 'bold'); // Use same font for bold to ensure glyphs render
    doc.setFont('NotoSansGujarati');
  }

  let yPos = 20;

  // Header
  doc.setFontSize(22);
  doc.setTextColor(4, 38, 59); // var(--accent)
  doc.text('Parivar Suraksha', 105, yPos, { align: 'center' });
  yPos += 10;
  doc.setFontSize(16);
  doc.text('Registration Confirmation', 105, yPos, { align: 'center' });
  yPos += 20;

  doc.setFontSize(12);
  doc.setTextColor(0, 0, 0);

  // Section: Basic Details
  doc.setFillColor(240, 240, 240);
  doc.rect(15, yPos - 5, 180, 10, 'F');
  doc.setFont('NotoSansGujarati', 'bold');
  doc.text('1. Basic Details', 20, yPos + 2);
  doc.setFont('NotoSansGujarati', 'normal');
  yPos += 15;

  doc.text(`પૂરું નામ: ${basicDetails.Name}`, 20, yPos);
  yPos += 10;
  doc.text(`Father Name: ${basicDetails.FatherName}`, 20, yPos);
  yPos += 10;
  doc.text(`Mother Name: ${basicDetails.MotherName}`, 20, yPos);
  yPos += 10;
  doc.text(`Email: ${basicDetails.Email}`, 20, yPos);
  yPos += 10;
  doc.text(`Mobile: ${basicDetails.Mobile}`, 20, yPos);
  yPos += 10;
  doc.text(`Date of Birth: ${basicDetails.DOB}`, 20, yPos);
  yPos += 10;
  doc.text(`Age: ${basicDetails.Age}`, 20, yPos);
  yPos += 10;
  doc.text(`Gender: ${basicDetails.Gender}`, 20, yPos);
  yPos += 10;
  doc.text(`Address: ${basicDetails.Address}, ${basicDetails.City}, ${basicDetails.State} - ${basicDetails.Pincode}`, 20, yPos);
  yPos += 10;
  doc.text(`Adhaar: ${basicDetails.AdhaarNumber}`, 20, yPos);
  yPos += 10;
  doc.text(`PAN: ${basicDetails.PANNumber}`, 20, yPos);
  yPos += 20;

  // Section: Nominee Details
  doc.setFillColor(240, 240, 240);
  doc.rect(15, yPos - 5, 180, 10, 'F');
  doc.setFont('NotoSansGujarati', 'bold');
  doc.text('2. Nominee Details', 20, yPos + 2);
  doc.setFont('NotoSansGujarati', 'normal');
  yPos += 15;

  doc.text(`Nominee Name: ${nomineeDetails.nomineeName}`, 20, yPos);
  yPos += 10;
  doc.text(`Relationship: ${nomineeDetails.relationship}`, 20, yPos);
  yPos += 10;
  doc.text(`Date of Birth: ${nomineeDetails.nomineeDob}`, 20, yPos);
  yPos += 10;
  doc.text(`Mobile: ${nomineeDetails.nomineeMobile}`, 20, yPos);
  yPos += 20;

  // Section: Health Declaration
  doc.setFillColor(240, 240, 240);
  doc.rect(15, yPos - 5, 180, 10, 'F');
  doc.setFont('NotoSansGujarati', 'bold');
  doc.text('3. Health Declaration', 20, yPos + 2);
  doc.setFont('NotoSansGujarati', 'normal');
  yPos += 15;

  doc.text(`Pre-existing Conditions: ${healthDeclaration.hasPreExistingConditions}`, 20, yPos);
  yPos += 10;
  if (healthDeclaration.hasPreExistingConditions === 'yes') {
    doc.text(`Condition Details: ${healthDeclaration.preExistingConditionDetails}`, 20, yPos);
    yPos += 10;
  }
  doc.text(`Smoker: ${healthDeclaration.isSmoker}`, 20, yPos);
  yPos += 10;
  doc.text(`Alcohol Consumer: ${healthDeclaration.isAlcoholConsumer}`, 20, yPos);
  yPos += 10;
  doc.text(`Surgery History: ${healthDeclaration.hasUndergoneSurgery}`, 20, yPos);
  yPos += 10;
  if (healthDeclaration.hasUndergoneSurgery === 'yes') {
    doc.text(`Surgery Details: ${healthDeclaration.surgeryDetails}`, 20, yPos);
    yPos += 10;
  }

  // Footer
  yPos += 20;
  doc.setFontSize(10);
  doc.setTextColor(100, 100, 100);
  doc.text('Generated by Parivar Suraksha App', 105, yPos, { align: 'center' });

  doc.save('ParivarSuraksha_Registration.pdf');
};